// Scroll-reveal: adds .is-visible to [data-reveal] once it enters the viewport.
export function initReveal() {
    document.querySelectorAll('[data-reveal]').forEach((section) => {
        const io = new IntersectionObserver((entries, obs) => {
            if (entries.some((e) => e.isIntersecting)) {
                section.classList.add('is-visible');
                obs.disconnect();
            }
        }, { threshold: 0.3 });
        io.observe(section);
    });
}
